interface TimeoutConfig {
    message: string
}

const defaultConfig: TimeoutConfig = {
    message: 'Task timed out'
}
export const runWithTimeout = async <T>(
    func: () => Promise<T> | undefined | void,
    timeLimit: number,
    config: TimeoutConfig = defaultConfig
): Promise<T | void> => {
    let timeoutId: any
    const asyncPromise = func()
    if (asyncPromise) {
        const timeoutPromise: Promise<void> = new Promise((_resolve, reject) => {
            timeoutId = setTimeout(() => reject(new Error(config.message)), timeLimit)
        })

        return Promise.race([asyncPromise, timeoutPromise]).then(result => {
            clearTimeout(timeoutId)
            return result
        })
    }
}

export const withTimeout = <T>(
    func: () => Promise<T> | undefined | void,
    timeLimit: number,
    config: TimeoutConfig = defaultConfig
): (() => Promise<T | void> | undefined | void) => {
    return () => runWithTimeout(func, timeLimit, config)
}
